export default __webpack_public_path__ + "static/media/mn.f3084cd9.png";